<template>
  <div class="nouveau-client-view">
    <NavBar />
    <div class="page">
      <header class="client-hero">
        <div>
          <p class="hero-kicker">Programme fidélité</p>
          <h2 class="page-title">Nouveau client</h2>
          <p class="page-subtitle">Créez une fiche client et associez sa carte fidélité en quelques secondes.</p>
        </div>
        <button class="btn btn-secondary retour-btn" @click="$router.push('/scanner')">← Retour au scanner</button>
      </header>

      <div class="card form-card" v-if="!succes">
        <div class="card-header">
          <div>
            <p class="section-kicker">Informations client</p>
            <h3>Identité et carte</h3>
          </div>
          <span class="required-note">* Obligatoire</span>
        </div>

        <div class="form-grid two">
          <div class="form-group">
            <label class="label">Prénom <span class="required">*</span></label>
            <input v-model="form.prenom" class="input" autocomplete="given-name" placeholder="Ex: Robin" />
          </div>
          <div class="form-group">
            <label class="label">Nom <span class="required">*</span></label>
            <input v-model="form.nom" class="input" autocomplete="family-name" placeholder="Ex: Poggioli" />
          </div>
        </div>

        <div class="form-group">
          <label class="label">Téléphone <span class="optionnel">(recommandé)</span></label>
          <input v-model="form.telephone" class="input" type="tel" inputmode="tel" autocomplete="tel" placeholder="06 00 00 00 00" />
          <p class="hint">Permet de retrouver le client plus facilement</p>
        </div>

        <div class="form-group">
          <label class="label">Numéro de carte <span class="required">*</span></label>
          <div class="carte-row">
            <input v-model="form.numero_carte" class="input carte-input" inputmode="numeric" placeholder="Ex: 000147" />
            <button class="btn btn-secondary generate-btn" @click="genererNumero">Générer</button>
          </div>
          <p class="hint">Numéro imprimé sur la carte physique remise au client</p>
        </div>

        <div class="rgpd-box">
          <label class="rgpd-label">
            <input type="checkbox" v-model="form.consentement_rgpd" />
            <span>Le client accepte que ses données soient enregistrées pour le programme de fidélité</span>
          </label>
          <p class="rgpd-hint">Consentement RGPD obligatoire</p>
        </div>

        <p v-if="erreur" class="message error">{{ erreur }}</p>

        <button
          class="btn btn-primary submit-btn"
          @click="inscrire"
          :disabled="!formValide || loading"
        >
          {{ loading ? 'Inscription...' : 'Inscrire le client' }}
        </button>
      </div>

      <!-- Succès -->
      <div class="card succes-card" v-if="succes">
        <div class="succes-icon">✓</div>
        <p class="section-kicker">Création confirmée</p>
        <h3>Client inscrit</h3>
        <div class="client-summary">
          <div class="summary-avatar">{{ succes.prenom ? succes.prenom[0] : '' }}{{ succes.nom ? succes.nom[0] : '' }}</div>
          <div>
            <strong>{{ succes.prenom }} {{ succes.nom }}</strong>
            <span>Carte n° {{ succes.numero_carte }}</span>
          </div>
        </div>
        <div class="points-summary">
          <span>Points de bienvenue</span>
          <strong>{{ succes.points_solde }} pts</strong>
        </div>
        <div class="succes-actions">
          <button class="btn btn-primary" @click="enchainerTransaction">
            Enregistrer un achat maintenant
          </button>
          <button class="btn btn-secondary" @click="reset">
            Inscrire un autre client
          </button>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import NavBar from '../components/NavBar.vue'
import api    from '../api'

export default {
  name: 'NouveauClientView',
  components: { NavBar },
  data() {
    return {
      form: {
        prenom:            '',
        nom:               '',
        telephone:         '',
        numero_carte:      '',
        consentement_rgpd: false
      },
      succes:  null,
      erreur:  '',
      loading: false
    }
  },
  computed: {
    formValide() {
      return this.form.prenom &&
             this.form.nom &&
             this.form.numero_carte &&
             this.form.consentement_rgpd
    }
  },
  watch: {
    "form.prenom"(val) { this.form.prenom = this.capitaliser(val) },
    "form.nom"(val)    { this.form.nom    = this.capitaliser(val) }
  },
  methods: {
    capitaliser(val) {
      if (!val) return ""
      return val
        .toLowerCase()
        .split(" ")
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ")
    },
    genererNumero() {
      // Numéro unique basé sur timestamp
      this.form.numero_carte = String(Date.now()).slice(-6)
    },
    enchainerTransaction() {
      // Passer le client au scanner via query params pour enchainer directement
      this.$router.push({
        path: '/scanner',
        query: { numero_carte: this.succes.numero_carte }
      })
    },
    async inscrire() {
      this.erreur  = ''
      this.loading = true
      try {
        const payload = {
          prenom:            this.form.prenom,
          nom:               this.form.nom,
          numero_carte:      this.form.numero_carte,
          consentement_rgpd: this.form.consentement_rgpd
        }
        if (this.form.telephone) payload.telephone = this.form.telephone

        const res    = await api.post('/clients', payload)
        this.succes  = res.data
      } catch (err) {
        this.erreur = err.response?.data?.error || 'Erreur lors de l\'inscription'
      } finally {
        this.loading = false
      }
    },
    reset() {
      this.form   = { prenom: '', nom: '', telephone: '', numero_carte: '', consentement_rgpd: false }
      this.succes = null
      this.erreur = ''
      this.genererNumero()
    }
  },
  mounted() {
    // Récupérer les paramètres passés depuis le Scanner
    const { prenom, nom, numero_carte } = this.$route.query
    if (prenom)       this.form.prenom       = prenom
    if (nom)          this.form.nom          = nom
    if (numero_carte) this.form.numero_carte = numero_carte
    else              this.genererNumero()
  }
}
</script>

<style scoped>
.nouveau-client-view {
  min-height: 100vh;
  background:
    radial-gradient(circle at 20% 0%, rgba(30, 111, 220, 0.09), transparent 28%),
    linear-gradient(180deg, #f8fafc 0%, #eef4fb 100%);
}

.page {
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  padding: 18px 14px 96px;
}

.client-hero {
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-bottom: 18px;
  padding: 8px 2px 0;
}

.hero-kicker,
.section-kicker {
  margin: 0 0 7px;
  color: var(--fm-accent);
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.page-title {
  margin: 0;
  color: var(--fm-text);
  font-size: 32px;
  font-weight: 850;
}

.page-subtitle {
  margin: 8px 0 0;
  color: var(--fm-muted);
  font-size: 15px;
  line-height: 1.6;
}

.retour-btn {
  width: 100%;
  min-height: 48px;
  white-space: nowrap;
}

.form-card {
  padding: 22px;
  border: 1px solid rgba(226, 232, 240, 0.9);
  border-radius: 18px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.07);
}

.card-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  margin-bottom: 20px;
  padding-bottom: 18px;
  border-bottom: 1px solid var(--fm-border);
}

.card-header h3 {
  margin: 0;
  color: var(--fm-navy);
  font-size: 21px;
  font-weight: 820;
}

.required-note {
  flex-shrink: 0;
  padding: 6px 10px;
  color: #b91c1c;
  background: var(--fm-danger-soft);
  border: 1px solid #fecaca;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
}

.form-grid {
  display: grid;
  gap: 16px;
}

.form-grid.two {
  grid-template-columns: 1fr;
}

.form-group {
  min-width: 0;
  margin-bottom: 18px;
}

.label {
  display: block;
  margin-bottom: 8px;
  color: #475569;
  font-size: 13px;
  font-weight: 760;
}

.input {
  min-height: 54px;
  padding: 15px 16px;
  border-radius: 14px;
  background: #fbfdff;
  font-size: 16px;
}

.input:focus {
  background: #ffffff;
}

.required {
  color: var(--fm-danger);
  font-size: 13px;
  font-weight: 800;
}

.optionnel {
  color: var(--fm-muted);
  font-size: 12px;
  font-weight: 500;
}

.hint {
  margin: 7px 0 0;
  color: #7c8a9a;
  font-size: 12px;
  line-height: 1.45;
}

.carte-row {
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
}

.carte-input {
  font-weight: 750;
  letter-spacing: 0.04em;
}

.generate-btn {
  min-height: 52px;
  white-space: nowrap;
}

.rgpd-box {
  margin-top: 4px;
  padding: 16px;
  background: #f8fafc;
  border: 1px solid var(--fm-border);
  border-radius: 16px;
}

.rgpd-label {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  color: #334155;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.45;
  cursor: pointer;
}

.rgpd-label input {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  margin-top: 1px;
  accent-color: var(--fm-accent);
}

.rgpd-hint {
  margin: 8px 0 0 34px;
  color: var(--fm-muted);
  font-size: 11px;
}

.message {
  margin-top: 16px;
  padding: 12px 14px;
  border-radius: 14px;
  font-size: 13px;
  font-weight: 750;
}

.error {
  color: #b91c1c;
  background: #fef2f2;
  border: 1px solid #fecaca;
}

.submit-btn {
  min-height: 56px;
  margin-top: 20px;
  font-size: 16px;
}

.succes-card {
  padding: 28px 22px;
  text-align: center;
  border: 1px solid rgba(187, 247, 208, 0.9);
  border-radius: 18px;
  box-shadow: 0 18px 45px rgba(15, 23, 42, 0.07);
}

.succes-icon {
  display: grid;
  place-items: center;
  width: 68px;
  height: 68px;
  margin: 0 auto 16px;
  color: #ffffff;
  background: linear-gradient(180deg, #34d399 0%, var(--fm-success) 100%);
  border-radius: 18px;
  font-size: 34px;
  font-weight: 900;
  box-shadow: 0 16px 30px rgba(34, 197, 94, 0.22);
}

.succes-card h3 {
  margin: 0 0 18px;
  color: var(--fm-navy);
  font-size: 25px;
  font-weight: 850;
}

.client-summary {
  display: flex;
  align-items: center;
  gap: 14px;
  margin: 0 0 14px;
  padding: 16px;
  text-align: left;
  background: #f8fafc;
  border: 1px solid var(--fm-border);
  border-radius: 16px;
}

.summary-avatar {
  display: grid;
  place-items: center;
  width: 50px;
  height: 50px;
  color: #ffffff;
  background: var(--fm-navy);
  border-radius: 16px;
  font-weight: 850;
  text-transform: uppercase;
}

.client-summary strong,
.client-summary span {
  display: block;
}

.client-summary strong {
  color: var(--fm-text);
  font-size: 16px;
  font-weight: 850;
}

.client-summary span {
  margin-top: 4px;
  color: var(--fm-muted);
  font-size: 13px;
}

.points-summary {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 22px;
  padding: 15px 16px;
  color: #166534;
  background: var(--fm-success-soft);
  border: 1px solid #bbf7d0;
  border-radius: 16px;
}

.points-summary span {
  font-size: 13px;
  font-weight: 750;
}

.points-summary strong {
  font-size: 20px;
  font-weight: 900;
}

.succes-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

@media (min-width: 620px) {
  .page {
    padding: 28px 22px 96px;
  }

  .client-hero {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 22px;
  }

  .retour-btn {
    width: auto;
    padding-inline: 18px;
  }

  .form-card,
  .succes-card {
    padding: 26px;
  }

  .form-grid.two {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .carte-row {
    grid-template-columns: minmax(0, 1fr) auto;
  }

  .generate-btn {
    width: auto;
    padding-inline: 18px;
  }
}

@media (min-width: 900px) {
  .page {
    max-width: 820px;
  }
}

@media (max-width: 420px) {
  .page-title {
    font-size: 29px;
  }

  .card-header {
    flex-direction: column;
  }

  .required-note {
    align-self: flex-start;
  }

  .client-summary {
    align-items: flex-start;
  }
}

:global(body.contraste-fort) .nouveau-client-view {
  background: #000000;
}

:global(body.contraste-fort) .form-card,
:global(body.contraste-fort) .succes-card,
:global(body.contraste-fort) .client-summary,
:global(body.contraste-fort) .points-summary,
:global(body.contraste-fort) .rgpd-box {
  border-color: #ffff00;
}

:global(body.contraste-fort) .hero-kicker,
:global(body.contraste-fort) .section-kicker,
:global(body.contraste-fort) .required-note {
  color: #ffff00;
}
</style>
